<template>
  <div class="order__response">
    <span class="order__response__title">Success</span>
    <svg xmlns="http://www.w3.org/2000/svg" width="183" height="183" viewBox="0 0 183 183" fill="none">
      <g clip-path="url(#clip0_1967_67076)">
        <path d="M91.5 0C105.693 0 119.124 3.23344 131.125 9.00076C126.213 12.8871 121.658 16.618 117.414 20.209C109.331 17.2709 100.61 15.6697 91.5155 15.6697C70.5759 15.6697 51.6106 24.1575 37.8996 37.884C24.173 51.6106 15.6853 70.5604 15.6853 91.5C15.6853 112.44 24.173 131.389 37.8996 145.116C51.6261 158.843 70.5759 167.33 91.5155 167.33C112.455 167.33 131.42 158.843 145.132 145.116C158.858 131.389 167.346 112.44 167.346 91.5C167.346 86.5255 166.864 81.6442 165.947 76.934C169.88 71.804 173.906 66.6896 178.025 61.6218C181.259 70.9801 183.016 81.038 183.016 91.5C183.016 116.761 172.771 139.644 156.215 156.2C139.66 172.756 116.777 183 91.5155 183C66.2543 183 43.3716 172.756 26.8158 156.2C10.2444 139.644 0 116.761 0 91.5C0 66.2388 10.2444 43.356 26.8002 26.8002C43.356 10.2444 66.2388 0 91.5 0ZM48.8746 76.4676L71.1978 76.1723L72.8611 76.6075C77.3693 79.2036 81.6132 82.1728 85.5772 85.5306C88.4376 87.9557 91.1735 90.5984 93.7696 93.4587C101.775 80.5716 110.31 68.7416 119.326 57.8598C129.198 45.9365 139.675 35.117 150.681 25.2457L152.858 24.4062H177.217L172.305 29.8626C157.21 46.6361 143.515 63.9692 131.141 81.8463C118.767 99.739 107.698 118.207 97.8581 137.219L94.7956 143.126L91.9819 137.11C86.7898 125.964 80.5716 115.735 73.1565 106.595C65.7413 97.4539 57.1137 89.3392 47.0558 82.4371L48.8746 76.4676Z" fill="#01A601"/>
      </g>
      <defs>
        <clipPath id="clip0_1967_67076">
          <rect width="183" height="183" fill="white"/>
        </clipPath>
      </defs>
    </svg>
    <span class="order__response__description">Your <span v-if="subscription">subscription</span><span v-else>order</span> has been Activated.</span>
  </div>
</template>

<script>
export default {
  name: 'OrderSuccess',
  props: {
    subscription: Boolean
  }
}
</script>

<style scoped>

</style>
